import { useRef } from 'react';
// eslint-disable-next-line import/no-internal-modules
import { useMenuList } from '@askyourteam-nz/react-library/dist/elements/selection';
import Option from './Option';

export const ListBox = (props) => {

  const ref = useRef();

  const {
    menuProps,
    state
  } = useMenuList(
    props,
    ref
  );

  const {
    collection
  } = state;

  return (
    <ul
      className={'filter-selection__list-box'}
      ref={ref}
      {...menuProps}
    >
      {[...collection].map(
        item => (
          <Option
            key={item.key}
            item={item}
            state={state}
          />
        )
      )}
    </ul>
  );
};

export default ListBox;
